import { createAction, handleActions } from 'redux-actions'
import produce from 'immer'

const UPDATE_EVENT_MODAL_STATE = 'eventModalStateAction/updateBankAccountState'

export const updateEventModalState = createAction(UPDATE_EVENT_MODAL_STATE)

const initialState = {
  eventModalVisible: false,
}

export default handleActions(
  {
    [UPDATE_EVENT_MODAL_STATE]: (state, action) => {
      return produce(state, (draft) => {
        draft.eventModalVisible = action.payload.eventModalVisible
      })
    },
  },
  initialState,
)
